import {
    addCookieValueToObject,
    getCookieValueByName,
    getParsedCookieValue,
    setCookie,
} from 'utils/cookies/utils';
import { useState } from 'react';
import { getPlacerCurrentDomain } from 'store/auth/utils/utils';

export const COOKIE_KEY = 'dismiss';
export const TEN_YEARS = 60 * 60 * 24 * 365 * 10;

export const useDismissibleMessage = ({ dismissId }: { dismissId: string }) => {
    const getKeys = () => {
        const dismissCookieValue = getCookieValueByName(COOKIE_KEY);
        return dismissCookieValue ? getParsedCookieValue(dismissCookieValue) : [];
    };

    const getVisibility = () => {
        const existingIds = getKeys();
        return !existingIds.includes(dismissId);
    };

    const [isVisible, setVisible] = useState(getVisibility());

    const onDismiss = () => {
        const existingIds = getKeys();

        setCookie({
            key: COOKIE_KEY,
            value: addCookieValueToObject(existingIds, dismissId),
            maxAge: TEN_YEARS,
            domain: getPlacerCurrentDomain(),
            secure: true,
        });
        setVisible(false);
    };

    return {
        isVisible,
        onDismiss,
    };
};
